<div class="tooltip" *ngIf="hasText" (mouseenter)="showHoverTooltip = true" (mouseleave)="showHoverTooltip = false" >
  <span class="pi pi-question-circle pi-big" (click)="showClickTooltip = !showClickTooltip"></span>
  <div [class.show]="showHoverTooltip || showClickTooltip" (click)="showClickTooltip = false" [innerHTML]="text"></div>
</div>
